import { render } from "./PatientCreate.vue?vue&type=template&id=4c15960a"
import script from "./PatientCreate.vue?vue&type=script&lang=ts"
export * from "./PatientCreate.vue?vue&type=script&lang=ts"
script.render = render

export default script